import he from 'he';

import parseJSON from './parseJSON';
import moment from 'components/momentWithZone';

let checkConflicts = (newProgram, inventory, cart, booking, IDtoCode) => {
	return new Promise((resolve, reject) => {
		const dateFormat = 'YYYY-MM-DD HH:mm';
		const fieldClasses = parseJSON(localStorage.fieldClasses, []).map(fieldClass => {
			return {
				ItemId: fieldClass.ItemId,
				Name: fieldClass.Name,
				start: fieldClass.BegDate,
				end: fieldClass.EndDate,
				valid: (fieldClass.BegDate !== null && fieldClass.EndDate !== null)
			};
		});

		const newDepart = moment(inventory[newProgram.Code].start, dateFormat);
		const newReturn = moment(inventory[newProgram.Code].end, dateFormat);

		// check program against cart
		const cartConflicts = cart.map(cartProgram => {
			// if new item depart <= old item return (plus 2 hours) and new item return >= old item depart (minus 2 hours), they conflict
			const cartDepart = moment(inventory[cartProgram.Code].start, dateFormat).subtract(2, 'hours');
			const cartReturn = moment(inventory[cartProgram.Code].end, dateFormat).add(2, 'hours');
			if (newDepart.isSameOrBefore(cartReturn) && newReturn.isSameOrAfter(cartDepart)) {
				return he.decode(cartProgram.Title) + ' ('+cartProgram.Code+')';
			}
			return null;
		}).filter(result => result != null);
		
		if (cartConflicts.length) {
			return reject(he.decode(newProgram.Title) + ' overlaps with programs in your cart: ' + cartConflicts.join(', '));
		}

		// check program against booking
		const bookedItems = booking;
		const bookingConflicts = bookedItems.filter(item => ['40','33'].indexOf(item.StoreId) !== -1).map(bookedProgram => {
			// field classes run from 8am to 8pm
			// but you can't have them on a day when you come back from a field program after midnight
			let bookedDepart, bookedReturn, name;
			let fieldProgram = inventory[IDtoCode[bookedProgram.ItemId]];
			let fieldClass = fieldClasses.find(FC => FC.ItemId === bookedProgram.ItemId);
			if (fieldProgram) {
				bookedDepart = moment(fieldProgram.start, dateFormat).subtract(2, 'hours');
				bookedReturn = moment(fieldProgram.end, dateFormat).add(2, 'hours');
				name = fieldProgram.Name;
			} else if (fieldClass) {
				if (fieldClass.valid) {
					bookedDepart = moment(fieldClass.start, dateFormat).hour(0).add(1, 'minutes');
					bookedReturn = moment(fieldClass.end, dateFormat).hour(20).add(2, 'hours');
				} else {
					console.error('Cannot detect conflicts for ItemId ', bookedProgram.ItemId);	
				}
				name = fieldClass.Name;
			} else {
				console.error('Cannot detect conflicts for ItemId ', bookedProgram.ItemId);
				return null;
			}
			if (newDepart.isSameOrBefore(bookedReturn) && newReturn.isSameOrAfter(bookedDepart)) {
				return name;
			}
			return null;
		}).filter(result => result != null);

		if (bookingConflicts.length) {
			return reject(he.decode(newProgram.Title) + ' overlaps with programs you are registered for: ' + bookingConflicts.join(', '));
		}

		resolve();
	});
}
module.exports = checkConflicts;


// WEBPACK FOOTER //
// ./portal-components/Portal/FieldPrograms/checkConflicts.js